/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_SlaInputs */

const en_mk_mx_sla = /** @type {(inputs: Mk_Mx_SlaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Written SLA`)
};

const id_mk_mx_sla = /** @type {(inputs: Mk_Mx_SlaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLA tertulis`)
};

/**
* | output |
* | --- |
* | "Written SLA" |
*
* @param {Mk_Mx_SlaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_sla = /** @type {((inputs?: Mk_Mx_SlaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_SlaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_sla(inputs)
	return en_mk_mx_sla(inputs)
});